// components/FolderList.tsx
import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { FolderDTO } from "types";
import { FolderActions, FolderContainer, FolderItem, FolderName, StyledFolderIcon } from "./FolderList.styled";
interface FolderListProps {
  folders: FolderDTO[];
  onFolderClick: (folder: FolderDTO) => void;
  onRenameFolder: (folder: FolderDTO) => void;
  onDeleteFolder: (folder: FolderDTO) => void;
}
const FolderList: React.FC<FolderListProps> = ({
  folders,
  onFolderClick,
  onRenameFolder,
  onDeleteFolder
}) => {
  const [anchorEls, setAnchorEls] = React.useState<{
    [key: string]: HTMLElement | null;
  }>({});
  const handleMenuOpen = (event: React.MouseEvent<SVGSVGElement, MouseEvent>, folderId: string) => {
    setAnchorEls((prev: {
      [key: string]: HTMLElement | null;
    }) => ({
      ...prev,
      [folderId]: event.currentTarget as unknown as HTMLElement
    }));
  };
  const handleMenuClose = (folderId: string) => {
    setAnchorEls(prev => ({
      ...prev,
      [folderId]: null
    }));
  };
  return <FolderContainer data-sentry-element="FolderContainer" data-sentry-component="FolderList" data-sentry-source-file="index.tsx">
            {folders.map(folder => <FolderItem key={folder.id}>
                    <div onClick={() => onFolderClick(folder)}>
                        <StyledFolderIcon />
                        <FolderName>{folder.name}</FolderName>
                    </div>
                    <FolderActions>
                        <MoreVertIcon onClick={e => handleMenuOpen(e, folder.id)} style={{
          cursor: "pointer"
        }} />
                        <Menu anchorEl={anchorEls[folder.id]} open={Boolean(anchorEls[folder.id])} onClose={() => handleMenuClose(folder.id)}>
                            <MenuItem onClick={() => {
            onRenameFolder(folder);
            handleMenuClose(folder.id);
          }}>
                                Rename
                            </MenuItem>
                            <MenuItem onClick={() => {
            onDeleteFolder(folder);
            handleMenuClose(folder.id);
          }}>
                                Delete
                            </MenuItem>
                        </Menu>
                    </FolderActions>
                </FolderItem>)}
        </FolderContainer>;
};
export default FolderList;